import _get from 'lodash/get';
import { Pixall, Google } from '../analytics/index.js';
import { getInventoryOwnerById, isVDP } from '../utilities/index.js';
import { inventoryTransformer as googleInventoryTransformer } from '../transformers/google/index.js';
import { productConfigTransformer as pixallProductConfigTransformer } from '../transformers/pixall/index.js';
import { valueEventCode } from '../constants/index.js';
const {
  getProductConfiguration
} = pixallProductConfigTransformer;

/**
 * @summary Sends event when lead is submitted by clicking on Send Offer button
 * @data listingId
 */
export const submitOfferButtonClick = function (_ref, option) {
  let {
    dataLayer
  } = _ref;
  if (option === void 0) {
    option = {};
  }
  const accelerateData = {
    cmp: 'drWidgetOfferSubmitted',
    linkName: 'drWidgetOfferSubmitted',
    drWidgetName: 'accelerate',
    drWidgetAction: 'offer submission clicked'
  };
  Google.sendClickEvent({
    eventElement: 'accelerate',
    eventAction: 'submit',
    eventResult: 'cta::submit-offer::accelerate'
  }, option);
  Pixall.sendClickEvent({
    calculatorType: 'payment',
    eventSource: 'lead',
    eventType: 'submit',
    feature: 'dr3',
    label: 'cta::submit-offer::accelerate',
    cdl: {
      eventProperties: {
        event: {
          valueEventCode: '7A7F'
        }
      }
    }
  }, dataLayer, option);
  return accelerateData;
};
export function creditAppSubmit(_ref2, option) {
  let {
    data = {},
    state,
    dataLayer
  } = _ref2;
  if (option === void 0) {
    option = {};
  }
  const {
    listingId,
    creditAppType
  } = data;
  const inventory = getInventoryOwnerById(state, listingId);
  const creditAppLabel = creditAppType === 'accelerate' ? 'amd' : 'saca';
  const accelerateData = {
    cmp: 'drCreditAppSuccessDisplayed',
    linkName: 'DR_CREDIT_APP_SUCCESS_DISPLAYED',
    drWidgetName: 'DR Credit App',
    drWidgetAction: 'offer submission clicked'
  };
  Google.sendClickEvent({
    eventElement: creditAppType,
    eventAction: 'submit',
    eventResult: `text-link::caca-${creditAppLabel}`,
    eventData: {
      vehicle: googleInventoryTransformer(inventory, {
        target: 'vehicle',
        dataLayer
      })
    }
  }, option);
  return accelerateData;
}

/**
 * @summary Sends event when the user submits scheduled test drive request
 * @data listingId
 */
export const testDriveSubmit = function (_ref3, option) {
  let {
    data = {},
    dataLayer,
    state
  } = _ref3;
  if (option === void 0) {
    option = {};
  }
  const {
    inventoryId
  } = data;
  const inventory = getInventoryOwnerById(state, inventoryId);
  const accelerateData = {
    linkName: 'DR_TEST_DRIVE_REQUESTED',
    drWidgetName: 'DR Schedule Test Drive',
    drWidgetAction: 'scheduled test drive requested'
  };
  Google.sendClickEvent({
    eventElement: 'accelerate',
    eventAction: 'submit',
    eventResult: 'lead::amd::request-test-drive',
    eventData: {
      vehicle: googleInventoryTransformer(inventory, {
        target: 'vehicle',
        dataLayer
      })
    }
  }, option);
  return accelerateData;
};

/**
 * @summary Sends click event when CTA on lead form is clicked
 * @data cmp, listingType, listingId
 * @events event1
 */

export async function sdpRequestAppointment(_ref4, option) {
  let {
    data = {},
    state,
    dataLayer
  } = _ref4;
  if (option === void 0) {
    option = {};
  }
  const isKBB = state?.brand === 'kbb';
  const {
    listingId,
    listingType,
    ...rest
  } = data;
  const inventory = getInventoryOwnerById(state, listingId);
  const zip = _get(dataLayer, 'user.zipCode', '');
  const {
    payments = {}
  } = state;
  const {
    interactions = {}
  } = payments;
  const {
    hasUpdatedNDSCalc = false,
    hasOpenedWallet = false,
    hasOpenedTradeIn = false
  } = interactions;
  const includeWalletData = hasUpdatedNDSCalc || hasOpenedWallet || hasOpenedTradeIn;
  const payload = {
    cmp: 'request_appt',
    zip,
    co_txt_url: 'Request Appointment',
    ...rest
  };
  if (isKBB) {
    payload.products = ';nx:request_appt:click';
    payload.linkName = 'Link Name';
  }
  const cdl = {
    eventProperties: {
      event: {
        valueEventCode: getProductConfiguration(inventory, includeWalletData)?.includes('my-wallet') ? valueEventCode.LEAD_WITH_MY_WALLET : valueEventCode.LEAD_WITH_TEST_DRIVE
      }
    }
  };
  Google.sendClickEvent({
    eventElement: `vdp_${listingType}`,
    eventResult: 'cta::request-appointment',
    eventData: {
      vehicle: googleInventoryTransformer(inventory, {
        target: 'vehicle',
        dataLayer
      })
    }
  }, option);
  Pixall.sendClickEvent({
    label: 'cta::request-appointment',
    eventSource: 'dealership',
    inventory,
    pixallData: {
      clickTypeToListingType: true
    },
    cdl
  }, dataLayer, option);
  return payload;
}

/**
 * @summary Sends click event when CTA on right rail lead form conformation modal in next steps is clicked
 */

export async function startCreditApplication(_ref5, option) {
  let {
    data = {},
    state = {},
    dataLayer
  } = _ref5;
  if (option === void 0) {
    option = {};
  }
  const {
    listingId,
    partner,
    placement = 'nba'
  } = data;
  const inventory = getInventoryOwnerById(state, listingId);
  const payload = {
    eventSource: 'lead',
    leadType: 'credit',
    feature: partner === 'saca' ? 'caca' : 'dr3',
    label: `str_crd_app_${partner}-${placement}`,
    pixallData: {
      clickTypeToListingType: isVDP(dataLayer)
    },
    cdl: {
      eventProperties: {
        event: {
          valueEventCode: valueEventCode.CREDIT_APP
        }
      }
    }
  };
  Pixall.sendClickEvent({
    ...payload,
    inventory
  }, dataLayer, option);
  Google.sendClickEvent({
    eventElement: 'dealer',
    eventResult: `text-link::${partner}::start-a-credit-application::nba`,
    eventData: {
      vehicle: googleInventoryTransformer(inventory, {
        target: 'vehicle',
        dataLayer
      })
    }
  }, option);
  return payload;
}
export async function drDealSubmissions(_ref6, option) {
  let {
    dataLayer,
    data = {}
  } = _ref6;
  if (option === void 0) {
    option = {};
  }
  const {
    uiContext
  } = data;
  const entryPointsMap = {
    creditApp: 'credit-app-nds',
    default: 'nds-continue-online',
    lead: 'nds-send-offer',
    nextSteps: 'credit-app-next-best-action-modal',
    paymentCard: 'credit-app-price-card',
    protectionList: 'vehicle-protection-program',
    testDrive: 'schedule-test-drive'
  };
  Pixall.sendClickEvent({
    calculatorType: 'payment',
    eventSource: 'lead',
    eventType: 'click',
    label: `cta::${entryPointsMap[uiContext]}::deal-submission`,
    pixallData: {
      clickTypeToListingType: isVDP(dataLayer)
    }
  }, dataLayer, option);
  return {};
}

/**
 * @summary Sends Pixall, Google events for the vehicle protection cta
 */
export function vehicleProtectionClick(_ref7, option) {
  let {
    data = {},
    dataLayer = {},
    event,
    state
  } = _ref7;
  if (option === void 0) {
    option = {};
  }
  const {
    listingId,
    listingType
  } = data;
  const currentPageName = _get(state, 'currentPageName', '');
  const inventory = getInventoryOwnerById(state, listingId);
  const eventElement = `${currentPageName}_${listingType.toLowerCase()}`;
  const eventResult = 'cta::explore-vehicle-protection-options::additional-protections';
  Google.sendClickEvent({
    eventElement,
    eventResult,
    eventData: {
      vehicle: googleInventoryTransformer(inventory, {
        target: 'vehicle',
        dataLayer
      })
    }
  }, option);
  Pixall.sendClickEvent({
    eventSource: 'protection-plan',
    inventory,
    label: eventResult,
    pixallData: {
      clickTypeToListingType: isVDP(dataLayer)
    }
  }, dataLayer, option);
  return {
    eventResult,
    eventElement
  };
}
export default {
  submitOfferButtonClick,
  creditAppSubmit,
  testDriveSubmit,
  sdpRequestAppointment,
  startCreditApplication,
  drDealSubmissions,
  vehicleProtectionClick
};